import React from "react";

import {
  ContentPlaceHolder,
  ContentPlaceHolderProps,
} from "@catchoftheday/cg-components";

type PlaceholderProps = ContentPlaceHolderProps & {
  uniqueKey: string;
};

export const Placeholder = (props: PlaceholderProps) => (
  <ContentPlaceHolder
    gradientRatio={0.9}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  />
);
